const translations = {
  "en": {
    "Bitcoin Dominance": "Bitcoin Dominance"
  },
  "zh-tw": {
    "Bitcoin Dominance": "比特幣主導地位"
  }
};

export default translations;
